import { useState } from "react";
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Spinner
} from "reactstrap";
import {
    ArrowLeft,
    Eye,
    EyeOff,
    Lock
} from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import { changePassword } from "../service/authApi";

import "../styles/ChangePasswordPage.css";

const ChangePasswordPage = () => {

    const [loading, setLoading] =
        useState(false);

    const [showCurrent, setShowCurrent] =
        useState(false);

    const [showNew, setShowNew] =
        useState(false);

    const [showConfirm, setShowConfirm] =
        useState(false);

    const [formData, setFormData] =
        useState({

            currentPassword: "",

            newPassword: "",

            confirmPassword: ""

        });

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {

        setFormData({

            ...formData,

            [e.target.name]: e.target.value

        });

    };

    const handleSubmit = async (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        if (!formData.currentPassword.trim()) {

            toast.error(
                "Current password is required"
            );

            return;

        }

        if (!formData.newPassword.trim()) {

            toast.error(
                "New password is required"
            );

            return;

        }

        if (
            formData.newPassword !==
            formData.confirmPassword
        ) {

            toast.error(
                "Passwords do not match"
            );

            return;

        }

        try {

            setLoading(true);

            const response =
                await changePassword({

                    currentPassword:
                        formData.currentPassword,

                    newPassword:
                        formData.newPassword

                });

            toast.success(response);

            setFormData({

                currentPassword: "",

                newPassword: "",

                confirmPassword: ""

            });

        }
        catch (error: any) {

            toast.error(

                error.response?.data?.message ||

                "Unable to change password."

            );

        }
        finally {

            setLoading(false);

        }

    };

    return (

        <div className="change-password-page">

            <Container>

                <Row className="justify-content-center py-5">

                    <Col lg="6">

                        <Card className="shadow border-0 change-card">

                            <CardBody className="p-5">

                                <div className="text-center mb-4">

                                    <div className="change-icon">

                                        <Lock size={35} />

                                    </div>

                                    <h2 className="mt-3">

                                        Change Password

                                    </h2>

                                    <p className="text-muted">

                                        Update your account password.

                                    </p>

                                </div>

                                <Form
                                    onSubmit={handleSubmit}
                                >

                                    <FormGroup>

                                        <Label>

                                            Current Password

                                        </Label>

                                        <div className="password-box">

                                            <Input

                                                type={
                                                    showCurrent
                                                        ? "text"
                                                        : "password"
                                                }

                                                name="currentPassword"

                                                value={formData.currentPassword}

                                                onChange={handleChange}

                                            />

                                            <button

                                                type="button"

                                                className="eye-btn"

                                                onClick={() =>
                                                    setShowCurrent(!showCurrent)
                                                }

                                            >

                                                {

                                                    showCurrent ?

                                                        <EyeOff size={18} />

                                                        :

                                                        <Eye size={18} />

                                                }

                                            </button>

                                        </div>

                                    </FormGroup>

                                    <FormGroup>

                                        <Label>

                                            New Password

                                        </Label>

                                        <div className="password-box">

                                            <Input

                                                type={
                                                    showNew
                                                        ? "text"
                                                        : "password"
                                                }

                                                name="newPassword"

                                                value={formData.newPassword}

                                                onChange={handleChange}

                                            />

                                            <button

                                                type="button"

                                                className="eye-btn"

                                                onClick={() =>
                                                    setShowNew(!showNew)
                                                }

                                            >

                                                {

                                                    showNew ?

                                                        <EyeOff size={18} />

                                                        :

                                                        <Eye size={18} />

                                                }

                                            </button>

                                        </div>

                                    </FormGroup>

                                    <FormGroup>

                                        <Label>

                                            Confirm Password

                                        </Label>

                                        <div className="password-box">

                                            <Input

                                                type={
                                                    showConfirm
                                                        ? "text"
                                                        : "password"
                                                }

                                                name="confirmPassword"

                                                value={formData.confirmPassword}

                                                onChange={handleChange}

                                            />

                                            <button

                                                type="button"

                                                className="eye-btn"

                                                onClick={() =>
                                                    setShowConfirm(!showConfirm)
                                                }

                                            >

                                                {

                                                    showConfirm ?

                                                        <EyeOff size={18} />

                                                        :

                                                        <Eye size={18} />

                                                }

                                            </button>

                                        </div>

                                    </FormGroup>

                                    <Button

                                        color="primary"

                                        className="w-100 mt-3"

                                        disabled={loading}

                                    >

                                        {

                                            loading ?

                                                <Spinner size="sm" />

                                                :

                                                "Change Password"

                                        }

                                    </Button>

                                </Form>

                               

                            </CardBody>

                        </Card>

                    </Col>

                </Row>

            </Container>

        </div>

    );

};

export default ChangePasswordPage;